const { createApp, ref, component, watch, onMounted, onBeforeMount, reactive } = Vue;
let isBundleComplete = true;
(() => {
	for (let index = 0; index < bundleData.steps.length; index++) {
		if (
			bundleData.steps[index].products ||
			bundleData.steps[index].variants ||
			bundleData.steps[index].collections ||
			bundleData.steps[index].product ||
			bundleData.steps[index].choices
		) {
			isBundleComplete = true;
		} else {
			isBundleComplete = false;
			console.log(`Bundle incomplete`, bundleData.steps[index]);
			break;
		}
	}
	// filtering incomplete steps
	bundleData.steps = bundleData.steps.filter((s) => {
		if (s.products || s.variants || s.collections || s.product || s.choices) {
			return s;
		}
	});
})();

const BundleApp = createApp({
	name: "BundleApp",
	setup() {
		let bundleLineItemPlaceholder = [];
		if (bundleData.steps.length > 0) {
			bundleLineItemPlaceholder = bundleData.steps.map((s, i) => {
				if (s.type === "bundle_default_product") {
					return {
						[`step_${i}`]: {
							type: s.type,
							line_items: [s.product],
						}
					};
				}
				return {
					[`step_${i}`]: {
						type: s.type,
						line_items: [],
					},
				};
			});
		}
		const bundleState = ref(bundleData);
		const bundleLineItemState = ref(bundleLineItemPlaceholder);
		const bundleAvailability = ref(checkBundleAvailability());

		function handleCSBProductUpdate(e) {
			bundleLineItemState.value[e.step_index][`step_${e.step_index}`].line_items = e.payload;
		}

		function checkBundleAvailability() {
			let availability = true;
			let bundleSteps = bundleState.value.steps;
			availabilityLoop: for (let i = 0; i < bundleSteps.length; i++) {
				if (bundleSteps[i].type === "bundle_product_select") {
					for (let j = 0; j < bundleSteps[i].products.length; j++) {
						if (
							bundleSteps[i].products[j].hasOwnProperty("available") &&
							bundleSteps[i].products[j].available === false
						) {
							availability = false;
							break availabilityLoop;
						}
					}
				}
				if (bundleSteps[i].type === "bundle_default_product") {
					if (bundleSteps[i].product.hasOwnProperty("available") && bundleSteps[i].product.available === false) {
						availability = false;
						break availabilityLoop;
					}
				}
				if (bundleSteps[i].type === "bundle_single_select_product") {
					for (let j = 0; j < bundleSteps[i].products.length; j++) {
						if (
							bundleSteps[i].products[j].hasOwnProperty("available") &&
							bundleSteps[i].products[j].available === false
						) {
							availability = false;
							break availabilityLoop;
						}
					}
				}
			}
			return isBundleComplete && availability;
		}

		function handleVariantChangedEmitted(e) {
			console.log(e)
			var prod_arr = [];
			bundleData.selected_variants = e.payload;
			e.payload.forEach((itm) => {
				prod_arr.push(itm.product);
			});
			bundleLineItemState.value[e.step_index][`step_${e.step_index}`].line_items = prod_arr;
			if (e.matching_addon) {
				const matchingAddonEventEmitter = new CustomEvent("matchingAddonEvent", {
					detail: e.matching_addon,
				});
				document.dispatchEvent(matchingAddonEventEmitter);
			}
		}

		function handleVariantUpdateEmitted(e) {
			var formatted_variant_arr = [];
			e.payload.forEach((variant, idx) => {
				formatted_variant_arr.push({
					current_selected_variant: variant,
				});
				if (e.payload.length == (idx = 1)) {
					bundleLineItemState.value[e.step_index][`step_${e.step_index}`].line_items = e.payload;
				}
			});
			// bundleLineItemState.value[e.step_index][`step_${e.step_index}`].line_items = e.payload;
			// console.log(bundleLineItemState.value);
		}

		function handleFixedVariantUpdate(e) {
			bundleLineItemState.value[e.step_index][`step_${e.step_index}`].line_items = e.payload;
		}

		return {
			bundleState,
			bundleLineItemState,
			bundleAvailability,
			imgUrl,
			formatMoney,
			handleCSBProductUpdate,
			handleVariantChangedEmitted,
			handleVariantUpdateEmitted,
			handleFixedVariantUpdate,
			calculateSavings,
		};
	},
	delimiters: ["${", "}"],
});

// product select block
BundleApp.component("product-step-block", {
	template: "#product-step-block",
	props: ["step", "index"],
	emits: ["on-variant-update"],
	setup(props, ctx) {
		let selectedBundleState = reactive([]);
		let shwVariantDropdown = ref(false);
		let selectedVariant = ref([]);
		let isOpened = ref(false);
		const searchString = ref('');

		onMounted(() => {
			setDefaultVariant();
		});

		// return color codes

		function getBackgroundColor(variant) {
			if (variant.option1 == "Metallic Silver" || variant.option1 == "Default Title") {
				return "#c0c0c0";
			} else if (variant.option1 == "Midnight Black") {
				return "#000000";
			} else {
				return variant.option1;
			}
		}

		function setDefaultVariant() {
			props.step.products.forEach((product) => {
				let firstAvailableVariant = null;
				product.variants.forEach((variant) => {
					console.log(variant.available, variant.hide_variant)
					if (variant.available === true) {
						if (!firstAvailableVariant) {
							firstAvailableVariant = variant;
						}
					}
				});
				if (firstAvailableVariant) {
					console.log(firstAvailableVariant)
					var prod_data = {
						product_id: product.id,
						variant_id: firstAvailableVariant.id,
						product: product,
					};
					prod_data.product.current_selected_variant = firstAvailableVariant;
					selectedVariant.value.push(firstAvailableVariant);
					selectedBundleState.push(prod_data);
				}
			});

			ctx.emit("on-variant-update", {
				step_index: props.index,
				payload: selectedBundleState,
			});
		}

		// check variant exists and check the radio

		function isVariantIdInArray(product_id, variant, pindex) {
			let isVariantFound = false;
			selectedBundleState.forEach((itm) => {
				if (itm.product_id == product_id && itm.variant_id == variant.id) {
					let element = this.$refs["bundle_stp_1__prd_image" + pindex];
					if (variant.featured_image) {
						element[0].attributes[1].value = imgUrl(variant.featured_image.src, "medium");
					}

					isVariantFound = true;
				}
			});
			if (isVariantFound) {
				return true;
			}
		}

		// radio on change listener

		function updateVariantIdInArray(target_elem, product, variant, pindex, toggleShown) {
			selectedBundleState.forEach((itm) => {
				if (itm.product_id == product.id) {
					itm.variant_id = variant.id;
					itm.product.current_selected_variant = variant;
				}
			});
			let element = this.$refs["bundle_stp_1__prd_image" + pindex];

			if (element) {
				if (variant.featured_image) {
					element[0].attributes[1].value = imgUrl(variant.featured_image.src, "medium");
				}
			}

			selectedVariant.value[pindex] = variant;


			ctx.emit("on-variant-update", {
				step_index: props.index,
				payload: selectedBundleState,
				matching_addon: product.tags.includes('NBA') ? variant.matching_addon : null
			});
			if (toggleShown) {
				toggleVariantDropdown(pindex);
			}

			isOpened.value = false;
		}

		// add or remove active class to dropdown

		function toggleVariantDropdown(pindex) {
			let target_data_att = "[data-elem-id='bundle_stp_1__prd_drp" + pindex + "']";
			let element = document.querySelector(target_data_att);

			if (element) {
				if (element.classList.contains("active")) {
					element.classList.remove("active");
				} else {
					element.classList.add("active");
				}
			}
		}

		// function handleVariantChange(e){
		// 	console.log(e)
		// 	let prod_data = {
		// 		product_id: e.data.id,
		// 		variant_id: e.data.current_selected_variant.id,
		// 		product: e.data,
		// 	};
		// 	selectedBundleState[e.index] = prod_data;

		// 	ctx.emit("on-variant-update", {
		// 		step_index: props.index,
		// 		payload: selectedBundleState,
		// 	});
		// }

		function shouldShowVariant(variant) {
			return !searchString.value ||
				variant.title.toLowerCase().includes(searchString.value.toLowerCase());
		}

		function setSwatchBg(variant) {
			if (variant && variant.custom_swatch) {
			  return `url(${variant.custom_swatch})`;
			}
			return getColorSwatch(variant.title);
		}

		return {
			selectedBundleState,
			shwVariantDropdown,
			selectedVariant,
			isOpened,
			searchString,
			imgUrl,
			buildImgSrc,
			getBackgroundColor,
			setDefaultVariant,
			isVariantIdInArray,
			updateVariantIdInArray,
			toggleVariantDropdown,
			formatMoney,
			getColorSwatch,
			setSwatchBg,
			shouldShowVariant
		};
	},
	delimiters: ["${", "}"],
})

// collection step block
BundleApp.component("collection-step-block", {
	template: "#collection-step-block",
	emits: ["on-productupdate"],
	props: ["step", "index", "fixed_variant", "max_oil", "variant_handle"],
	setup(props, ctx) {
		const toggleDropdown = ref(false);
		const toggleProductDropdown = ref(false);
		const selectedCollection = ref("");
		const isProductLoading = ref(false);
		const collectionProducts = ref([]);
		const selectedProducts = ref([]);
		function handleToggleDropdown() {
			toggleDropdown.value = !toggleDropdown.value;
		}
		function handleToggleProductDropdown() {
			toggleProductDropdown.value = !toggleProductDropdown.value;
		}
		function handleCollectionSelect(title, handle) {
			selectedCollection.value = { title, handle };
			selectedProducts.value = [];
			collectionProducts.value = [];
			handleToggleDropdown();
			ctx.emit("on-productupdate", { step_index: props.index, payload: selectedProducts.value });
		}

		watch(selectedCollection, async () => {
			let products = await getCollectionProducts();
			if (props.fixed_variant && props.variant_handle) {
				products = products.filter((product) => {
					product.variants = product.variants.filter(
						(variant) => variant.title.includes(props.variant_handle) && variant.available
					);
					return product.variants.length > 0; // Keep the product if it has at least one variant that satisfies the condition.
				});
			}
			collectionProducts.value = products;
		});

		async function getCollectionProducts() {
			try {
				isProductLoading.value = true;
				let resp = await fetch(`https://aroma360.com/collections/${selectedCollection.value.handle}/products.json`, {
					method: "GET",
				}).then((resp) => resp.json());
				return resp.products;
			} catch (error) {
				console.log(error);
			} finally {
				isProductLoading.value = false;
			}
		}

		function handleProductSelect(product, event) {
			let currentProducts = selectedProducts.value;
			product.current_selected_variant = getFirstAvailableVariant(product);
			if (event.target.type === "radio") {
				currentProducts = [product];
			}
			if (event.target.type === "checkbox") {
				currentProducts.push(product);
				if (!event.target.checked) {
					currentProducts = currentProducts.filter((p) => p.id != product.id);
				}
			}
			selectedProducts.value = currentProducts;
			if (props.max_oil && selectedProducts.value.length === props.max_oil) {
				handleToggleProductDropdown();
			}
			ctx.emit("on-productupdate", { step_index: props.index, payload: selectedProducts.value });
		}

		function getFirstAvailableVariant(product) {
			let variant = product.variants.filter((p) => p.available);
			if (variant[0]) return variant[0];
			return [];
		}

		function handleCheckBoxSelection(id) {
			return selectedProducts.value.some((p) => p.id === id);
		}

		function handleSelectionRestrict(id) {
			if (props.max_oil && props.max_oil > 1) {
				let isSelectedProduct = selectedProducts.value.some((p) => p.id === id);
				if (props.max_oil === selectedProducts.value.length && !isSelectedProduct) return true;
			}
			return false;
		}

		return {
			toggleDropdown,
			selectedCollection,
			isProductLoading,
			collectionProducts,
			selectedProducts,
			handleToggleDropdown,
			handleCollectionSelect,
			handleProductSelect,
			handleToggleProductDropdown,
			toggleProductDropdown,
			handleCheckBoxSelection,
			handleSelectionRestrict,
			imgUrl,
			buildImgSrc,
			formatMoney,
		};
	},
	delimiters: ["${", "}"],
})

// fixed variant step
BundleApp.component("fixed-variant-step-block", {
	template: "#fixed-variant-step-block",
	emits: ["on-variant-update"],
	props: ["step", "index", "max_oil"],
	setup(props, ctx) {
		const selectedAddon = ref(null);
		const filterOptions = ref([]);
		const selectedFilter = ref('*');
		const filteredProductArr = ref([]);
		const searchString = ref('');
		const addonDropdownEl = ref(null);
		const isDropdownOpen = ref(false);

		onBeforeMount(() => {
			filterOptions.value = props.step.product_sets;
			filteredProductArr.value = props.step.variants;
			const firstAvailableVariant = filteredProductArr.value.find(v => v.available);
			if (firstAvailableVariant) selectedAddon.value = firstAvailableVariant;
			if (props.step.disable_dropdown_toggle) isDropdownOpen.value = true;
		});

		onMounted(() => {
			matchVariantAddon();
		})

		watch(selectedAddon, () => {
			if (selectedAddon.value) {
				if (!props.step.disable_dropdown_toggle) isDropdownOpen.value = false;
				ctx.emit("on-variant-update", {
					step_index: props.index,
					payload: [selectedAddon.value],
				});
			}
		});

		function handleVariantChange(e) {
			selectedAddon.value = filteredProductArr.value.find(p => p.id === e);
		}

		function handleVariantCheck(id) {
			return id === selectedAddon.value.id;
		}

		function handeFilterChange(e) {
			selectedFilter.value = e;
			filteredProductArr.value = props.step.variants.filter(p => p.set_id === e);
			if (selectedFilter.value === '*') {
				filteredProductArr.value = props.step.variants;
			}
			if (searchString.value.length > 0) {
				filteredProductArr.value = filteredProductArr.value.filter(p => {
					const regex = new RegExp(searchString.value, 'i');
					if (regex.test(p.name)) return p;
				});
			};
			addonDropdownEl.value.scrollTo({
				top: 0,
			});
		}

		function handleChecked(id) {
			return id === selectedFilter.value;
		}

		function handleClose() {
			ctx.emit("on_close", null)
		}

		function handleConfirm() {
			if (selectedAddon.value) {
				ctx.emit("on_addon_confirm", {
					addon_product: selectedAddon.value
				});

				resetSearchFilter();
			}
		}

		function renderNoResults() {
			return searchString.value == '' ? "No products found" : `No products found for '${searchString.value}'`;
		}

		function resetSearchFilter() {
			searchString.value = '';
			resetSetFilter();
		}

		function handleSearch(e) {
			searchString.value = e.target.value;
			if (searchString.value.length > 0) {
				filteredProductArr.value = props.step.variants.filter(p => {
					const regex = new RegExp(searchString.value, 'i');
					if (regex.test(p.name)) return p;
				});
			} else {
				handeFilterChange(selectedFilter.value);
			}
		}

		function resetSetFilter() {
			selectedFilter.value = '*';
			filteredProductArr.value = props.step.variants;
			if (addonDropdownEl.value) {
				addonDropdownEl.value.scrollTo({
					top: 0,
				});
			}

		}

		function matchVariantAddon() {
			document.addEventListener("matchingAddonEvent", (event) => {
				if (filteredProductArr.value.find(p => p.id === event.detail.id)) {
					selectedAddon.value = filteredProductArr.value.find(p => p.id === event.detail.id)
				}
			});
		}

		function toggleDropdown() {
			if (!props.step.disable_dropdown_toggle) isDropdownOpen.value = !isDropdownOpen.value;
		}


		return {
			selectedAddon,
			filterOptions,
			selectedFilter,
			filteredProductArr,
			searchString,
			addonDropdownEl,
			isDropdownOpen,
			handleVariantCheck,
			resetSetFilter,
			toggleDropdown,
			calculateDiscount,
			renderNoResults,
			handeFilterChange,
			handleVariantChange,
			handleChecked,
			handleClose,
			handleConfirm,
			formatMoney,
			buildImgSrc,
			handleSearch,
			matchVariantAddon
		}
	},
	delimiters: ["${", "}"],
})

// add to cart floating bar
BundleApp.component("bundle-add-to-cart", {
	template: "#bundle-add-to-cart",
	props: ["bundle_items", "bundle_code", "parent_product", "bundle_availability"],
	setup(props) {
		const isReadyToSubmit = ref(false);
		const isSubmitting = ref(false);
		const errMsg = ref("");

		onMounted(() => {
			validateLineItems(false);
		});

		async function handleBundleAddToCart() {
			if (props.bundle_availability && validateLineItems((showError = true))) {
				//validation goes here
				isSubmitting.value = true;
				try {
					await fetch(window.Shopify.routes.root + "cart/add.js", {
						method: "POST",
						headers: {
							"Content-Type": "application/json",
						},
						body: JSON.stringify({ items: formatBundleForLineItems() }),
					}).then((resp) => resp.json());
				} catch (error) {
					console.log(error);
				} finally {
					isSubmitting.value = false;
				}
			}
		}

		watch(props.bundle_items, () => {
			validateLineItems();
		});

		function validateLineItems(showError = false) {
			errMsg.value = "";
			let errMsgTxt = "";
			let isValid = true;
			for (let i = 0; i < props.bundle_items.length; i++) {
				const s = props.bundle_items[i];
				if (s[`step_${i}`].type === "bundle_collection_select") {
					if (s[`step_${i}`].line_items.length < 1) {
						errMsgTxt = `Please select a collection and product in step ${i + 1}`;
						isValid = false;
						break;
					}
				}

				if (s[`step_${i}`].type === "bundle_variant_select") {
					if (s[`step_${i}`].line_items.length < 1) {
						errMsgTxt = `Please select a product in step ${i + 1}`;
						isValid = false;
						break;
					}
				}

				if (s[`step_${i}`].type === "bundle_variant_choice") {
					if (s[`step_${i}`].line_items.length < 1) {
						errMsgTxt = `Please select a product in step ${i + 1}`;
						isValid = false;
						break;
					}
				}

				if (s[`step_${i}`].type === "bundle_single_select_product") {
					if (s[`step_${i}`].line_items.length < 1) {
						errMsgTxt = `Please select a product in step ${i + 1}`;
						isValid = false;
						break;
					}
				}
			}
			isReadyToSubmit.value = isValid;
			if (showError) errMsg.value = errMsgTxt;
			return isValid;
		}

		function formatBundleForLineItems() {
			const { parent_product } = props
			const bundleTitle = parent_product.title
			let bundleSlashedOutPrice = parent_product.compare_at_price;
			let bundleSalePrice = parent_product.price
			const bundleImage = parent_product.featured_image
			const bundleHandle = parent_product.handle
			const bundleDiscountValueNode = document.querySelector('.sale_discount')
			bundleSalePrice = formatMoney(bundleSalePrice)
			bundleSlashedOutPrice = formatMoney(bundleSlashedOutPrice)

			let reqPayLoad = [];
			let bundleProductsTitle = []
			props.bundle_items.forEach((s, i) => {
				let lineItemsTitle = s[`step_${i}`].line_items.map((e) => {
					console.log(e)
					if (s[`step_${i}`].type === "bundle_default_product" || s[`step_${i}`].type === "bundle_variant_select" || s[`step_${i}`].type === "bundle_single_select_product" || s[`step_${i}`].type === 'bundle_variant_choice') {
						let name;
						if (e.name && e.name.includes('Discount Card')) {
							name = e.title + ' ' + e.name
						} else {
							name = e.name
						}
						return name
					} else {
						if (e.current_selected_variant) {
							//console.log('r22', e)
							let title;
							if (e.current_selected_variant.name) {
								title = e.current_selected_variant.name
							} else {
								title = e.title + ' - ' + `${e.current_selected_variant.title == "Default Title" ? '' : e.current_selected_variant.title}`
							}
							return title
						}
					}
				});
				bundleProductsTitle.push(...lineItemsTitle);
			});
			bundleProductsTitle = bundleProductsTitle.reduce((accumulator, currentArray) => {
				return accumulator.concat(currentArray);
			}, []);
			function arrayToObjWithPrefix(arr, prefix) {
				const obj = {};
				arr.forEach((element, index) => {
					obj[`${prefix}${index + 1}`] = element;
				});
				return obj;
			}

			const prefix = "product_";
			const bundleProductTitleObj = arrayToObjWithPrefix(bundleProductsTitle, prefix);

			console.log({ bundleProductsTitle })

			String.prototype.hashCode = function () {
				var hash = 0,
					i, chr;
				if (this.length === 0) return hash;
				for (i = 0; i < this.length; i++) {
					chr = this.charCodeAt(i);
					hash = ((hash << 5) - hash) + chr;
					hash |= 0; // Convert to 32bit integer
				}
				return hash;
			}

			function concatenateAndHashStrings(arr) {
				const concatenatedString = arr.join('').replace(/\s/g, ''); // Remove spaces
				const hashedValue = concatenatedString.hashCode(); // Get hashed value
				return hashedValue.toString(); // Convert to string
			}


			const hashedValue = concatenateAndHashStrings(bundleProductsTitle);
			// console.log('hashedValue', bundleProductsTitle ,hashedValue);



			const properties = {
				_bundle_code: props.bundle_code,
				_bundle_hash: hashedValue,
				_bundle_parent_id: props.parent_product.variants[0].id.toString(),
				_bundle_title: bundleTitle,
				_bundle_slashed_out_price: bundleSlashedOutPrice,
				_bundle_sale_price: bundleSalePrice,
				_bundle_off_value: bundleDiscountValueNode?.innerHTML || null,
				_bundle_img: bundleImage,
				_bundle_url: `/products/${bundleHandle}`,
				_bundle_products: bundleProductTitleObj
			};
			const productTypeCounter = {}
			props.bundle_items.forEach((s, i) => {
				let lineItems = s[`step_${i}`].line_items.map((e) => {
					// console.log(e.id, "step index", i, "formatting line item",e);
					if (s[`step_${i}`].type === "bundle_default_product") {
						productTypeCounter[e?.main_product.type] = productTypeCounter[e?.main_product.type] ? productTypeCounter[e?.main_product.type]+1 : 1;
						return {
							quantity: 1,
							id: e.id,
							properties: { ...properties, _compare_at_price: e.compare_at_price || 0, _compare_at_price_discount: 0,_bundle_product_type:`${e?.main_product.type}_${productTypeCounter[e?.main_product.type]}` , _bundle_variant_img: e.featured_image?.src ? e.featured_image?.src : e.main_product?.featured_image }
						};
					}
					if (s[`step_${i}`].type === "bundle_variant_select" || s[`step_${i}`].type === "bundle_variant_choice") {
						productTypeCounter[e?.main_product.type] = productTypeCounter[e?.main_product.type] ? productTypeCounter[e?.main_product.type]+1 : 1;
						return {
							quantity: 1,
							id: e.id,
							properties: { ...properties, _compare_at_price: e.compare_at_price || 0, _compare_at_price_discount: 0,_bundle_product_type:`${e?.main_product.type}_${productTypeCounter[e?.main_product.type]}`, _bundle_variant_img: e.featured_image?.src ? e.featured_image?.src : e.main_product?.featured_image }
						};
					}
					if (s[`step_${i}`].type === "bundle_single_select_product") {
						productTypeCounter[e?.main_product.type] = productTypeCounter[e?.main_product.type] ? productTypeCounter[e?.main_product.type]+1 : 1;
						return {
							quantity: 1,
							id: e.id,
							properties: { ...properties, _compare_at_price: e.compare_at_price || 0, _compare_at_price_discount: 0,_bundle_product_type:`${e?.main_product.type}_${productTypeCounter[e?.main_product.type]}` }
						};
					}

					productTypeCounter[e?.type] = productTypeCounter[e?.type] ? productTypeCounter[e?.type]+1 : 1;

					return {
						quantity: 1,
						id: e.current_selected_variant.id,
						properties: { ...properties, _compare_at_price: e.current_selected_variant.compare_at_price || 0, _compare_at_price_discount: 0,_bundle_product_type:`${e?.type}_${productTypeCounter[e?.type]}`, _bundle_variant_img: e.current_selected_variant?.featured_image?.src ? e.current_selected_variant?.featured_image?.src : e.main_product?.featured_image }
					};
				});
				reqPayLoad.push(...lineItems);
			});
			reqPayLoad = reqPayLoad.reduce((accumulator, currentArray) => {
				return accumulator.concat(currentArray);
			}, []);
			return reqPayLoad;
		}

		return {
			isSubmitting,
			errMsg,
			isReadyToSubmit,
			handleBundleAddToCart,
			formatMoney,
			calculateSavings,
		};
	},
	delimiters: ["${", "}"],
})

// bundle default product or gift
BundleApp.component("bundle-default-product", {
	template: "#bundle-default-product",
	props: ["step", "index"],
	setup(props) {
		return {
			imgUrl,
			formatMoney,
			buildImgSrc
		};
	},
	delimiters: ["${", "}"],
})

BundleApp.component("single-select-product", {
	template: "#bundle-single-select-product",
	props: ["step", "index"],
	setup(props, ctx) {
		const selectedProduct = ref(null);
		const availableVariants = ref([]);
		const selectProdVariants = ref([]);
		const toggleVariantDropdown = ref(false);

		// show hide dropdown

		function handleToggleVariantDropdown() {
			toggleVariantDropdown.value = !toggleVariantDropdown.value;
		}

		function handleProductSelect(e, product) {
			toggleVariantDropdown.value = false;
			selectedProduct.value = product;
			availableVariants.value = [];
			selectProdVariants.value = [];
			if (product.variants) {
				availableVariants.value = product.variants.filter((v) => v.available);
			}
			ctx.emit("on-fixed-variant-update", {
				step_index: props.index,
				payload: selectProdVariants.value,
			});
			if (availableVariants.value.length === 1) {
				selectProdVariants.value = [availableVariants.value[0]];
				ctx.emit("on-fixed-variant-update", {
					step_index: props.index,
					payload: selectProdVariants.value,
				});
			}
		}

		function handleSelectedProduct(id) {
			if (selectedProduct.value && selectedProduct.value.id === id) {
				return true;
			}
			return false;
		}

		function handleVariantSelect(variant, e) {
			selectProdVariants.value = [variant];
			ctx.emit("on-fixed-variant-update", {
				step_index: props.index,
				payload: selectProdVariants.value,
			});
			handleToggleVariantDropdown();
		}

		function handleRadioForSelectedVariant(id) {
			if (selectProdVariants.value.length && selectProdVariants.value[0].id === id) {
				return true;
			}
			return false;
		}

		return {
			imgUrl,
			buildImgSrc,
			formatMoney,
			handleProductSelect,
			availableVariants,
			selectProdVariants,
			handleVariantSelect,
			selectedProduct,
			handleToggleVariantDropdown,
			toggleVariantDropdown,
			handleSelectedProduct,
			handleRadioForSelectedVariant,
		};
	},
	delimiters: ["${", "}"],
});

BundleApp.component("product-variant-select", {
	template: "#variantSelect",
	props: ["selected_product", "p_index"],
	emits: ["on_variant_change"],
	setup(props, ctx) {
		const variantContEl = ref(null);
		const selectedProd = ref(props.selected_product);
		onMounted(() => {
			handleVariantChecked();
			hideUnRelatedVariants();
		})

		function handleVariantChecked() {
			if (variantContEl.value) {
				selectedProd.value.current_selected_variant.options.forEach(option_value => {
					variantContEl.value.querySelectorAll(`input[type='radio'][value='${option_value}']`).forEach(el => {
						el.checked = true;
					});
				});
			}
		}

		function hideUnRelatedVariants() {
			const optionWithValues = selectedProd.value?.options_with_values;
			const activeOptions = [...selectedProd.value?.current_selected_variant.options];
			const productVariants = selectedProd.value.variants;
			const swatchGroups = variantContEl.value.querySelectorAll('.variant-block__swatch');
			variantContEl.value.querySelectorAll(`input[type='radio']`).forEach(el => el.parentElement.classList.remove('hide-option'));
			swatchGroups.forEach((grpEl, i) => {
				let groupPosition = parseInt(grpEl.getAttribute('data-option-position'));
				if (optionWithValues.length > 1 && groupPosition > 1 && groupPosition <= optionWithValues.length) {
					const primaryOptions = activeOptions.slice(0, i);
					let groupInputs = grpEl.querySelectorAll('input[type="radio"]');
					if (groupInputs) {
						groupInputs.forEach(el => {
							let isPartOfAnyVariant = false;
							for (let variant of productVariants) {
								const optionCombination = [...primaryOptions, el.value];
								const isUnRelatedVariant = optionCombination.every(o => variant.options.includes(o));
								if (isUnRelatedVariant) {
									isPartOfAnyVariant = true;
									break;
								}
							}
							if (!isPartOfAnyVariant) {
								el.parentElement.classList.add('hide-option');
							}
						});
					}
				}
			});
			hideUnwantedVarintOptions();
			ctx.emit("on_variant_change", { data: selectedProd.value, index: props.p_index });
		}

		function handleVariantSelect(e) {
			const selectedOptionArr = [];
			const selectedVariantInputRadio = variantContEl.value.querySelectorAll("input[type='radio']:checked");
			const productVariants = selectedProd.value.variants;
			let matchedVariant = null;
			selectedVariantInputRadio.forEach(el => {
				selectedOptionArr.push(el.value);
			});
			if (selectedOptionArr.length) {
				console.log(selectedOptionArr)
				for (let variant of productVariants) {
					const isSelectedVariant = selectedOptionArr.every(o => variant.options.includes(o));
					if (isSelectedVariant) {
						matchedVariant = variant;
						break;
					}
				}
				if (matchedVariant) {
					console.log(matchedVariant)
					selectedProd.value.current_selected_variant = matchedVariant;
				} else {
					let partialCombination = [e.target.value];
					if (selectedOptionArr.length > 2) {
						const optionsLength = productObj.value?.options_with_values.length;
						partialCombination = selectedOptionArr.slice(0, optionsLength - 1);
					}
					for (let variant of productVariants) {
						const isSelectedVariant = partialCombination.every(o => variant.options.includes(o));
						if (isSelectedVariant) {
							matchedVariant = variant;
							break;
						}
					}
					if (!matchedVariant) {
						matchedVariant = productVariants.find(variant => variant.options.includes(e.target.value));
					}
				}
			}
			else {
				console.log('assa')
			}
			selectedProd.value.current_selected_variant = matchedVariant;
			handleVariantChecked();
			hideUnRelatedVariants();
			// ctx.emit("on_variant_change", selectedVariant.value);
		}

		function hideUnwantedVarintOptions() {
			const hasStyles = selectedProd.value?.options_with_values.some(item => item.name === "Style");
			if (hasStyles) {
				const styleElem = document.querySelector('div[data-option-name="Style"]');
				const variantOptItemElem = styleElem.querySelectorAll('.variant-option__item');
				variantOptItemElem.forEach(item => {
					const inputElement = item.querySelector('input');
					if (inputElement && !hideMainProductVariants.includes(inputElement.value)) {
						item.classList.add('hide-option');
					}
				});
			}
		}

		function checkProductStatus(options) {
			console.log(options)
			return true
		}

		return {
			variantContEl,
			handleize,
			getColorSwatch,
			handleVariantChecked,
			handleVariantSelect,
			checkProductStatus
		}
	},
	delimiters: ["${", "}"],
});

BundleApp.component("bundle-variant-choice", {
	template: "#fixed-variant-choice-step-block",
	props: ["step", "index"],
	emits: ["on-variant-update"],
	setup(props, ctx) {
		const selectedVariant = ref(null);

		onMounted(() => {
			const firstAvailableVariant = props.step.choices.find(c => c.available);
			if (firstAvailableVariant) {
				selectedVariant.value = firstAvailableVariant;
				ctx.emit("on-variant-update", {
					step_index: props.index,
					payload: [selectedVariant.value],
				});
			}
		});

		function handleChecked(id) {
			return id === selectedVariant.value?.id;
		}

		function handleVariantChange(variant) {
			selectedVariant.value = variant;
			ctx.emit("on-variant-update", {
				step_index: props.index,
				payload: [selectedVariant.value],
			});
		}

		return {
			selectedVariant,
			buildImgSrc,
			handleChecked,
			handleVariantChange,
			formatMoney
		}
	},
	delimiters: ["${", "}"],
})


BundleApp.mount("#productBundleBlock");

// helpers common to all the components

function imgUrl(url, size) {
	// remove any current image size then add the new image size
	return url
		.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, ".")
		.replace(/\.jpg|\.png|\.gif|\.jpeg/g, function (match) {
			return "_" + size + match;
		});
}

function buildImgSrc(src, fallBack, size) {
	//console.log(src,fallBack,size,"function params");
	let defaultUrl = 'https://new-aroma360.myshopify.com/cdn/shop/files/Artboard_1_2x_d1f7cce2-c16c-4e43-9f31-5381cc2f4c60.png';
	if (src) return imgUrl(src, size);
	if (fallBack) return imgUrl(fallBack, size);
	return imgUrl(defaultUrl, size);
}

function formatMoney(cents, format = "") {
	if (typeof cents === "string") {
		cents = cents.replace(".", "");
	}
	const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
		formatString = format || window.themeVariables.settings.moneyFormat;
	function defaultTo(value2, defaultValue) {
		return value2 == null || value2 !== value2 ? defaultValue : value2;
	}
	function formatWithDelimiters(number, precision, thousands, decimal) {
		precision = defaultTo(precision, 2);
		thousands = defaultTo(thousands, ",");
		decimal = defaultTo(decimal, ".");
		if (isNaN(number) || number == null) {
			return 0;
		}
		number = roundNumber(number / 100, false, precision);
		let parts = number.split("."),
			dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
			centsAmount = parts[1] ? decimal + parts[1] : "";
		return dollarsAmount + centsAmount;
	}
	let value = "";
	switch (formatString.match(placeholderRegex)[1]) {
		case "amount":
			value = formatWithDelimiters(cents, 2);
			break;
		case "amount_no_decimals":
			value = formatWithDelimiters(cents, 0);
			break;
		case "amount_with_space_separator":
			value = formatWithDelimiters(cents, 2, " ", ".");
			break;
		case "amount_with_comma_separator":
			value = formatWithDelimiters(cents, 2, ".", ",");
			break;
		case "amount_with_apostrophe_separator":
			value = formatWithDelimiters(cents, 2, "'", ".");
			break;
		case "amount_no_decimals_with_comma_separator":
			value = formatWithDelimiters(cents, 0, ".", ",");
			break;
		case "amount_no_decimals_with_space_separator":
			value = formatWithDelimiters(cents, 0, " ");
			break;
		case "amount_no_decimals_with_apostrophe_separator":
			value = formatWithDelimiters(cents, 0, "'");
			break;
	}
	if (formatString.indexOf("with_comma_separator") !== -1) {
		return formatString.replace(placeholderRegex, value);
	} else {
		return formatString.replace(placeholderRegex, value);
	}
	function roundNumber(num, savings, precision = 2) {
		if (isNaN(num)) {
			return;
		}

		let nummm = num.toFixed(3).split(".")[1].slice(2);
		if (nummm > 4 && !savings) {
			let number = Math.ceil((num + Number.EPSILON) * 100) / 100;
			return number.toFixed(precision);
		} else if (nummm < 6 && savings) {
			let number = Math.floor((num + Number.EPSILON) * 100) / 100;
			return number.toFixed(precision);
		} else {
			let number = Math.round((num + Number.EPSILON) * 100) / 100;
			return number.toFixed(precision);
		}
	}
}

function calculateDiscountedPrice(salePrice = 0, discount = 0) {
	if (salePrice < 0 || discount < 0) {
		throw "Sale price and discount must be non-negative values.";
	}
	const discountAmount = (discount / 100) * salePrice;
	const discountedPrice = salePrice - discountAmount;
	return discountedPrice;
}

function calculateSavings(originalPrice, discountedPrice) {
	if (originalPrice > 0) {
		const percentageDiscount = ((originalPrice - discountedPrice) / originalPrice) * 100;
		return Math.round(percentageDiscount).toFixed(0);
	} else {
		return 0;
	}
}

function calculateDiscount(price, discountValue, discountValueType) {
	if (discountValue === 0 || discountValue === undefined || discountValue === null) {
		return null;
	}
	if (discountValueType === 'PERCENTAGE') {
		let discountedPrice = price * (discountValue / 100);
		return Number(roundNumber(price - discountedPrice, false));
	}
	if (discountValueType === 'FIXED') {
		let discountedPrice = price * (fixedDiscountToPercentage(price / 100, discountValue) / 100);
		return Number(roundNumber(price - discountedPrice, false));
	};
}

function getColorSwatch(variantName) {
	const colorMapping = {
		'midnight black': '#00040d',
		'miami heat black': '#00040d',
		'black': '#00040d',
		'negro': '#00040d',
		'miami heat negro': '#00040d',
		'negro medianoche': '#00040d',
		'medianoche': '#00040d',
		'medianoche negro': '#00040d',
		'aroma x hc collab wireless pro - black': '#00040d',
		'aroma x hc collab wireless pro - negro': '#00040d',
		'silver': '#BCC6CC',
		'metallic silver': '#BCC6CC',
		'metallic': '#BCC6CC',
		'plata metálico': '#BCC6CC',
		'metálico': '#BCC6CC',
		'plata': '#BCC6CC',
		'mickey mouse silver': '#BCC6CC',
		'mickey mouse metálico': '#BCC6CC',
		'medianoche metálico': '#BCC6CC',
		'blue': '#465999',
		'azul': '#465999',
		'green': '#758270',
		'verde': '#758270',
		'red': '#932A30',
		'rojo': '#932A30',
		'purple': '#800080',
		'morado': '#800080',
		'pink': '#EDC6BF',
		'fly': '#EDC6BF',
		'rosado': '#EDC6BF',
		'aroma x hc collab wireless pro - champagne': '#e5d2bd',
		'aroma x hc collab wireless pro - champan': '#e5d2bd',
		'champagne': '#e5d2bd',
		'aroma x hc collab wireless pro - space grey': '#717378',
		'aroma x hc collab wireless pro - espacio gris': '#717378',
		'space gray': '#717378',
		'donald duck': '#3b80df',
		'princess': '#E73F85',
		'mickey mouse': '#00040d',
		'darth vader': '#000000',
		'storm trooper': '#d3d3d3',
		'c-3po': '#ebbb52',
		'light side': '#fafafa',
		'dark side': '#000',
		'r2-d2': '#002eff'
		// Add more colors as needed
	};

	const lowercaseName = variantName.toLowerCase();
	let colorCode = "#ffffff";
	for (const key in colorMapping) {
		if (lowercaseName.includes(key)) {
			colorCode = colorMapping[key];
			break;
		}
	}
	return colorCode;
}


function handleize(str) {
	return str.toLowerCase().replace(/\s+/g, '-')
		.replace(/[^\w\-]+/g, '')
		.replace(/\-\-+/g, '-')
		.replace(/^-+/, '')
		.replace(/-+$/, '');
}